import { ComponentProps } from "react";

const CheckIcon = (props: ComponentProps<"svg">) => {
  return (
    <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_15557_159700)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 40C0 17.9086 17.9086 0 40 0C62.0816 0.0239062 79.9761 17.9184 80 40C80 62.0914 62.0914 80 40 80C17.9086 80 0 62.0914 0 40ZM34.9992 56.6664C34.1227 56.667 33.2546 56.4949 32.4447 56.1597C31.6348 55.8245 30.8989 55.3329 30.2792 54.713L17.6659 42.383C17.0338 41.7642 16.6734 40.9196 16.664 40.035C16.6546 39.1505 16.997 38.2985 17.6159 37.6664C18.2347 37.0343 19.0793 36.6739 19.9638 36.6645C20.8484 36.6551 21.7004 36.9975 22.3325 37.6164L34.9759 49.973L57.6625 27.6397C58.3023 27.0768 59.1334 26.7803 59.985 26.8111C60.8365 26.8419 61.644 27.1976 62.2414 27.8053C62.8389 28.413 63.1809 29.2264 63.1972 30.0784C63.2135 30.9304 62.9029 31.7563 62.3292 32.3864L39.6859 54.743C39.0695 55.356 38.3383 55.8415 37.5341 56.1715C36.7299 56.5015 35.8685 56.6697 34.9992 56.6664Z"
          fill={props.color ?? "currentColor"}
        />
      </g>
      <defs>
        <clipPath id="clip0_15557_159700">
          <rect width="80" height="80" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default CheckIcon;
